import { render, staticRenderFns } from "./Broadcast.vue?vue&type=template&id=6a046de2&scoped=true"
import script from "./Broadcast.vue?vue&type=script&lang=js"
export * from "./Broadcast.vue?vue&type=script&lang=js"
import style0 from "./Broadcast.vue?vue&type=style&index=0&id=6a046de2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a046de2",
  null
  
)

export default component.exports